/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconography = require("../iconography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Select = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(Select, _React$PureComponent);

  function Select() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = Select.prototype;

  _proto.componentDidMount = function componentDidMount() {
    require('../../css/select');
  };

  _proto.render = function render() {
    return _react["default"].createElement("span", {
      className: "pui-select"
    }, _react["default"].createElement("select", this.props), _react["default"].createElement(_iconography.Icon, {
      src: "chevron_down"
    }));
  };

  return Select;
}(_react["default"].PureComponent);

exports.Select = Select;